import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'
import { FilterBar, DeptSelect, getDateRange, mln, TA_CSS } from './tovarShared'

const STATUS = {
	dead: { label: 'st_dead', bg: '#fef2f2', color: '#b91c1c' },
	slow: { label: 'st_slow', bg: '#eff6ff', color: '#2563eb' },
	overstock: { label: 'st_overstock', bg: '#fffbeb', color: '#b45309' },
}
// Kategoriya kartalari (skrinshotdagi tartib: dead / overstock / slow)
const CATS = [
	{ key: 'dead', field: 'dead', bg: '#fef2f2', bd: '#fecaca', color: '#b91c1c', label: 'st_dead', ic: 'uil-exclamation-triangle' },
	{ key: 'overstock', field: 'overstock', bg: '#fffbeb', bd: '#fde68a', color: '#b45309', label: 'st_overstock', ic: 'uil-layers' },
	{ key: 'slow', field: 'slow', bg: '#eff6ff', bd: '#bfdbfe', color: '#2563eb', label: 'st_slow', ic: 'uil-clock' },
]

function Frozen() {
	const { t } = useTranslation()
	const [data, setData] = useState({ items: [], total_frozen: 0, count: 0, dead: 0, slow: 0, overstock: 0 })
	const [quick, setQuick] = useState('month')
	const [range, setRange] = useState(getDateRange('month'))
	const [custom, setCustom] = useState({ start: null, end: null })
	const [dept, setDept] = useState('')

	const load = useCallback(async (r, dp) => {
		const params = { start_date: r.start, end_date: r.end }
		if (dp) params.department = dp
		const res = await GET('/analytics/frozen', params, { loader: true })
		if (httpOk(res)) setData(res.data)
	}, [])
	useEffect(() => { load(range, dept) }, [range, dept, load])

	function onQuick(id) { setQuick(id); setCustom({ start: null, end: null }); setRange(getDateRange(id)) }
	function onCustom(s, e) {
		setCustom({ start: s, end: e })
		if (s && e) { setQuick(''); const f = d => d.toISOString().slice(0, 10); setRange({ start: f(s), end: f(e) }) }
	}

	return (
		<>
			<style>{TA_CSS}</style>
			<div className="ta">
				<div className="ta-head">
					<div>
						<h4>{t('frozen_title')}</h4>
						<div className="ta-hint">{t('frozen_hint')}</div>
					</div>
					<div className="ta-tools">
						<DeptSelect value={dept} onChange={setDept} t={t} />
						<FilterBar quick={quick} custom={custom} onQuick={onQuick} onCustom={onCustom} t={t} />
					</div>
				</div>

				{/* KPI */}
				<div className="ta-kpis">
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: '#fef2f2', color: '#dc2626' }}><i className="uil-money-stack" /></div>
						<div className="ta-kpi-l">{t('total_frozen')}</div>
						<div className="ta-kpi-v" style={{ color: '#b91c1c' }}>{mln(data.total_frozen)}</div>
						<div className="ta-kpi-s">{data.count} {t('goods')}</div>
					</div>
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: '#fef2f2', color: '#dc2626' }}><i className="uil-exclamation-triangle" /></div>
						<div className="ta-kpi-l">{t('st_dead')}</div>
						<div className="ta-kpi-v">{data.dead}</div>
						<div className="ta-kpi-s">{t('dead_sub')}</div>
					</div>
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: '#fffbeb', color: '#d97706' }}><i className="uil-layers" /></div>
						<div className="ta-kpi-l">{t('st_overstock')}</div>
						<div className="ta-kpi-v">{data.overstock}</div>
						<div className="ta-kpi-s">{t('overstock_sub')}</div>
					</div>
				</div>

				{/* Kategoriyalar */}
				<div className="ta-catrow">
					{CATS.map(c => (
						<div className="ta-cat" key={c.key} style={{ background: c.bg, borderColor: c.bd, color: c.color }}>
							<div className="ta-cat-ic" style={{ color: c.color }}><i className={c.ic} /></div>
							<div className="ta-cat-t">{t(c.label)}</div>
							<div className="ta-cat-sub" style={{ color: c.color }}>{t('frozen_cat_hint')}</div>
							<div className="ta-cat-v">{data[c.field]} <span style={{ fontSize: 14, fontWeight: 600 }}>{t('positions')}</span></div>
						</div>
					))}
				</div>

				{/* Jadval */}
				<div className="ta-block">
					<div className="ta-block-h">
						<i className="uil-snowflake me-1" />{t('frozen_title')}
						<span className="ta-pill" style={{ marginLeft: 8, background: '#f1f5f9', color: '#475569' }}>{data.count} {t('goods')}</span>
					</div>
					<div className="ta-scroll">
						<table className="ta-tbl">
							<thead>
								<tr>
									<th style={{ width: 36 }}>#</th>
									<th>{t('name')}</th>
									<th className="ta-num">{t('in_stock')}</th>
									<th className="ta-num">{t('stock_value_col')}</th>
									<th className="ta-num">{t('days_no_move')}</th>
									<th className="ta-num">{t('consumption_period')}</th>
									<th className="text-center">{t('status')}</th>
								</tr>
							</thead>
							<tbody>
								{data.items.map((r, i) => {
									const st = STATUS[r.status]
									return (
										<tr key={r.id}>
											<td className="ta-num" style={{ color: '#94a3b8' }}>{i + 1}</td>
											<td>
												<div className="fw-semibold">{r.name}</div>
												<div className="ta-sub">
													{r.unit || '—'} · {r.last_sold ? `${t('last_move')} ${formatDate(r.last_sold, 'dd.MM.yyyy')}` : t('no_move')}
												</div>
											</td>
											<td className="ta-num">{mln(r.stock_qty)} {r.unit}</td>
											<td className="ta-num fw-bold" style={{ color: '#b91c1c' }}>{mln(r.stock_value)}</td>
											<td className="ta-num">{r.days_no_move == null ? '—' : r.days_no_move}</td>
											<td className="ta-num" style={{ color: '#64748b' }}>{mln(r.sold_period)} {r.unit}</td>
											<td className="text-center"><span className="ta-pill" style={{ background: st.bg, color: st.color }}>{t(st.label)}</span></td>
										</tr>
									)
								})}
								{data.items.length === 0 && <tr><td colSpan={7} className="ta-empty">{t('no_frozen')}</td></tr>}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default Frozen
